/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from 'react';
import { Outlet } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import BaseCom from './BaseCom';

export const LayoutGlobal = {
  ConsoleMode: false,
  setConsoleMode: (mode) => {}
};

export class Layout extends BaseCom {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      consoleMode: false
    };
  }
  async componentDidMount() {
    await this.getLoginAsync();
  }

  setConsoleMode = (on) => {
    LayoutGlobal.ConsoleMode = on;
    this.setState({ consoleMode: on });
    document.body.classList.toggle('console', on);
  }

  render() {
    return (
      <>
        <ScrollToTop />
        <main className="main">
          <Outlet />
        </main>
      </>
    );
  }
}
